import { t } from './i18n.js';

let initialized = false;

export function addTOCEntry(label, latestValue, href) {
    const toc = document.querySelector('.wp-block-rank-math-toc-block nav ul');
    if (!toc) return;

    if (!initialized) {
        const headingLi = document.createElement('li');
        const heading = document.createElement('a');
        heading.id = 'data-charts-heading';
        heading.href = '#chart-container-0';
        heading.textContent = t('chart_labels.Data_Head', 'Market Data Charts');
        headingLi.appendChild(heading);
        toc.insertBefore(headingLi, toc.firstChild || null);
        initialized = true;
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = href;
    a.textContent = latestValue ? `${label}: ${latestValue}` : label;
    li.appendChild(a);
    toc.appendChild(li);
}
